import UserIcon from '@/assets/user.svg?react';

import PadlockIcon from '@/assets/padlock.svg?react';
import TitledCard from '@/components/ui/TitledCard';

import CheckboxPrivacyPolicy from '../components/CheckboxPrivacyPolicy';
import InputEmail from '../components/InputEmail';
import InputFirstName from '../components/InputFirstName';
import InputLastName from '../components/InputLastName';
import InputPhone from '../components/InputPhone';
import { useLingui } from '@lingui/react';

const Step2ContactDetails = () => {
  const { i18n } = useLingui();

  return (
    <TitledCard
      title={i18n.t('Twoje dane kontaktowe')}
      className="p-[14px] md:p-6"
    >
      <div className="flex flex-col gap-3">
        <div className="flex flex-col gap-2 rounded-lg bg-gray-200 p-[14px] md:gap-3 md:p-6">
          <div className="flex items-center gap-2">
            <UserIcon width={16} className="shrink-0 text-primary" />
            <p className="h5 text-oxford-blue-500">
              {i18n.t('Dane podstawowe')}
            </p>
          </div>

          <div className="grid grid-cols-3 gap-2 md:gap-3">
            <InputFirstName />
            <InputLastName />
          </div>

          <div className="grid grid-cols-3 gap-2 md:gap-3">
            <InputPhone />
            <InputEmail />
          </div>

          <div>
            <CheckboxPrivacyPolicy />
          </div>
        </div>

        <div className="flex items-center gap-2 rounded-md bg-gray-200 px-[14px] py-3 md:px-6">
          <PadlockIcon width={16} className="shrink-0 text-blue-600" />
          <p className="caption-large text-oxford-blue-300">
            {i18n.t(
              'Twoje dane są potrzebne do obsługi zamówienia i kontaktu z Tobą.'
            )}
          </p>
        </div>
      </div>
    </TitledCard>
  );
};

export default Step2ContactDetails;
